import { setElementHtml } from '@local_modules/generic/dom/set-element-html.js'
import { generateRandomString } from '@local_modules/generic/text/generate-random-string/index.js'
import { activateActions } from './activate-actions.js'
import { checkPageRestriction } from '../../../../helpers/restrictions/check-page-restriction.js'
import { applyHtmlRestrictions } from '../../../../helpers/restrictions/apply-html-restrictions.js'
import { fillString } from '@local_modules/generic/string-template.js'

import htmlTemplateIndex from './index.html'
import { showSelectors } from './show-selectors.js'
import { updateView, context, gridApi } from './update-view.js'
import { loadChartOfAccounts } from '../../../../helpers/app-data-loaders/load-charts-of-accounts.js'

/**
 *
 * @returns
 */
export async function showPageWhatHasBeenDonePg (params) {
  console.log('showPageWhatHasBeenDonePg')
  const { containerElementId, browserAppUser, browserAppAccount } = params

  // add allowNoAccount?: true to allow direct entity (NOT DONE)
  if (!checkPageRestriction({ browserAppUser, browserAppAccount, allowPublic: true })) return

  // Prepare the html
  let htmlIndex = htmlTemplateIndex
  htmlIndex = applyHtmlRestrictions(htmlIndex, { browserAppAccount, browserAppUser })
  const elementId = 'i' + generateRandomString()
  htmlIndex = fillString(htmlIndex, { elementId })

  // Inject in the page
  setElementHtml(containerElementId, htmlIndex)

  document.title = ['What has been done:', browserAppAccount.data.appAccount.name].join(' ')

  // Set full height
  document.getElementById(containerElementId).classList.add('position-absolute')
  document.getElementById(containerElementId).classList.add('top-to-bottom')

  const [loadedChartOfAccounts] = await Promise.all([
    loadChartOfAccounts(browserAppAccount.data.appAccount.id)
  ])

  context.currenciesForAccount = browserAppAccount.data.currenciesForAccount
  context.pgChartOfAccounts = loadedChartOfAccounts

  context.browserAppAccount = browserAppAccount
  context.entities = browserAppAccount.data.entities

  showSelectors(updateView, context)

  activateActions(document.getElementById(elementId), gridApi)
}
